import store from '../store'

const vFilter= new Map<string, any>();
vFilter.set("statusFil",function (value: number) {
    let statusStr = "";
    switch(value){
        case 1:
            statusStr = "一评"
            break;
        case 2:
            statusStr = "二评"
            break;
        case 3:
            statusStr = "三评"
            break;
        case 4:
            statusStr = "审核"
            break;
        default:
            statusStr = String(value)
            break;
    }
    return statusStr;
})



vFilter.set("checkType",function (value: number) {
    let checkType = "";
    switch (value) {
        case 0:
            checkType ="单评"
            break;
        case 1:
            checkType = "三评"
            break;
        default:
            checkType = String(value)
            break;

    }
    return checkType;

})

/**
 * 时间只保留日期，删除时间
 */
vFilter.set("toDate",function (value: string) {
    if(!value){
        return "——";
    }
    if(value&&value.length > 10){
        return value.substring(0,10)
    }
    return value;
})
/**
 * 时间到今天共几年
 */
vFilter.set("toYear",function (value: string) {
    const time1 = new Date(value).getTime();
    const time2 = new Date().getTime();
    const year = Math.floor((time2 - time1)/1000/60/60/24/365.25);
    return year;
})

/**
 * 保留1位小数
 */
vFilter.set("numToFixed",function (value: any) {
    if(value == "-") return value;
    if (value == undefined || isNaN(value) || value == -Infinity || value == Infinity) {
        return 0;
    }
    if (!isNaN(value) && value % 1 === 0) {
        return value;
    } else {
        return parseFloat(value.toFixed(2));
    }
    return value;
})

vFilter.set("packageSurveyRange",function (surveyRanges: any) {
    let str = '';
    if(surveyRanges){
        surveyRanges.forEach((sr: any) => {
            if(sr.lowerLimit == '' && sr.lowerUnit == '' && sr.upperUnit == '' && sr.upperLimit == ''){
                return;
            }
            if(sr.lowerUnit == sr.upperUnit){
                str +=  sr.prefix + ' (' + sr.lowerLimit + sr.symbol + sr.upperLimit + ') ' + sr.upperUnit  + sr.suffix + ";\n";
            }else{
                str +=  sr.prefix + ' ' + sr.lowerLimit + sr.lowerUnit + sr.symbol + sr.upperLimit + sr.upperUnit + ' ' + sr.suffix + ";\n";
            }
        });
    }
    return str;
})

/**
 * 性别
 */
vFilter.set("gender",function (value: string) {
    let str = "未设置";
    if(value == "0") str = "男";
    if(value == "1") str = "女";
    return str;
})

/**
 * 是否强检
 */
vFilter.set("strong",function (value: string) {
    let str = "-";
    if(value == "0") str = "否";
    if(value == "1") str = "是";
    return str;
})

/**
 * 隐藏字符串的中间部分
 */
vFilter.set("hideCenter",function (value: string) {
    let str = "";
    if(store.state && store.state.AuthedUser && store.state.AuthedUser.type != 0 && value){
        const reg = /^(\d{3})\d{4}(\d{4})$/;
        if(value.length == 11 && !isNaN(Number(value))){
            str = value.replace(reg, "$1****$2");
        }else if(value.length > 4){
            str = value.replace(value.substring(2, value.length-2),"****");
        }else{
            str = "****"
        }
    }else{
        str = value;
    }
    return str;
})

/**
 * 证书类型
 */
vFilter.set("toCertType",function (value: string) {
    let str = "未设置";
    if(value == "1") str = "检定";
    if(value == "2") str = "校准";
    if(value == "3") str = "检定中止";
    if(value == "4") str = "校准中止";
    if(value == "5") str = "测试";
    if(value == "6") str = "测试中止";
    if(value == "——") str = "——";
    return str;
})

/**
 * 授权证书类型
 */
vFilter.set("toAuthCertType",function (value: string) {
    let str = "未设置";
    if(value == "0") str = "检定";
    if(value == "1") str = "校准";
    if(value == "2") str = "商品量";
    return str;
})



export default vFilter
